<template>
  <div class="bodycontent">
    <div class="page_title">
      车队设置
    </div>
    <div class="page_form">
      <el-form :model="formData" size="small" label-width="260px">
        <el-form-item label="积分归集">
          <el-radio-group v-model="formData.account_type">
            <el-radio label="0">总账户</el-radio>
            <el-radio label="1">子账户</el-radio>
          </el-radio-group>
          <div class="form_info_text">
            如总账户，即表示子账户消费时积分也会到总账户里去， 子账户则表示
            不会归集到 总账户
          </div>
        </el-form-item>
        <!-- xizneng -->
        <el-form-item label="优惠券归集">
          <el-radio-group v-model="formData.coupon_type">
            <el-radio label="0">总账户</el-radio>
            <el-radio label="1">子账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分配额度最大数">
          <el-input
            class="input_box"
            v-model="formData.max_amount"
            placeholder="请输入额度"
          ></el-input
          >元
          <div class="form_info_text">
            给子账户分配的额度
          </div>
        </el-form-item>
        <el-form-item label="子账户付款时是否获取主账户手机号">
          <el-radio-group v-model="formData.is_master_mobile">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否开启关联限制">
          <el-radio-group v-model="formData.is_relation">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="最大关联数"
          v-if="formData.is_relation == 0 || formData.is_relation == '0'"
        >
          <el-input
            class="input_box"
            v-model="formData.relation_num"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否开启车队入驻审核">
          <el-radio-group v-model="formData.is_auth">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="save_button">
      <el-button size="small" type="primary" @click="save()">确定</el-button>
    </div>
  </div>
</template>
<script>
import { getSet, Set } from "@/api/motorcade";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      formData: {
        account_type: "0",
        coupon_type: "0",
        max_amount: "",
        is_master_mobile: "0",
        is_relation: "0",
        relation_num: "",
        is_auth: "0"
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      getSet(data).then(res => {
        if (res.code == 200) {
          console.log(res.data);
          this.formData.account_type = String(res.data.account_type);
          this.formData.coupon_type = String(res.data.coupon_type);
          this.formData.is_master_mobile = String(res.data.is_master_mobile);
          this.formData.is_relation = String(res.data.is_relation);
          this.formData.is_auth = String(res.data.is_auth);
          this.formData.max_amount = res.data.max_amount;
          this.formData.relation_num = res.data.relation_num;
        } else {
          this.$message(res.msg);
        }
      });
    },
    save() {
      var data = { ...this.formData };
      data.token = this.token;
      data.app_id = this.app_id;
      console.log(data);
      // return false;
      Set(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功"
          });
          this.init();
        } else {
          this.$message(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form {
    padding-top: 30px;
    .input_box {
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small {
      width: 50px;
    }
    .form_info_text {
      color: #aaa;
    }
  }
  .save_button {
    margin-top: 25px;
    padding-left: 200px;
    margin-bottom: 50px;
  }
}
</style>
